import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

export interface IPropsIcon {
  size?: number;
  viewBox?: string;
  fill?: string;
  smallSize?: number;
  onClick?: () => void;
}
export const BaseIcon = ({
  size,
  smallSize,
  viewBox,
  fill = 'none',
  children,
  onClick,
}: PropsWithChildren<IPropsIcon>) => {
  return (
    <>
      <Container
        size={size}
        smallSize={smallSize}
        viewBox={viewBox}
        fill={fill}
        xmlns='http://www.w3.org/2000/svg'
        style={{ cursor: 'pointer' }}
        onClick={onClick && onClick}
      >
        {children}
      </Container>
    </>
  );
};

const Container = styled.svg<any>(
  ({ size, smallSize }) => `
  width: ${size}px;
  height: ${size}px;
  
  @media only screen and (max-width: 768px) {
    width: ${smallSize || size}px;
    height: ${smallSize || size}px;
    margin-top: 3px;
  }
`
);
